"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.function.name.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _index = _interopRequireDefault(require("@/components/ReportNav/index.vue"));

var _utils = require("@/utils");

var _report = require("@/api/report");

var _common = require("@/api/common");

var _report2 = require("@/config/report");

var _vuex = require("vuex");

var _help = _interopRequireDefault(require("@/config/help.json"));

var _LineChart = _interopRequireDefault(require("@/components/Chart/LineChart.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'ReportGeneral',
  components: {
    ReportNav: _index.default,
    LineChart: _LineChart.default
  },
  data: function data() {
    return {
      help: _help.default,
      drawer: false,
      pageConfig: {
        info: {},
        chartInfo: [],
        totalFrame: 0,
        optimize: []
      },
      pageKey: '',
      activeNames: [],
      activeNamesDrawer: [],
      tableData1: [{
        id: 1,
        name: 'GPU耗时均值',
        value: '143.ms',
        num: 2,
        children: [{
          id: 11,
          name: '',
          value: '建议小于8ms',
          num: '查看更多',
          isChild: true
        }]
      }, {
        id: 2,
        name: '渲染耗时均值',
        value: '3.8ms',
        num: 2,
        children: [{
          id: 21,
          name: '',
          value: '建议小于8ms',
          num: '查看更多',
          isChild: true
        }]
      }, {
        id: 3,
        name: '逻辑耗时均值',
        value: '4.2ms',
        num: 2,
        children: [{
          id: 31,
          name: '',
          value: '建议小于8ms',
          num: '查看更多',
          isChild: true
        }]
      }],
      optimize: [],
      data: {},
      drawerList: [],
      score: 'SSS'
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['reportDevice'])),
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var informRes, fileRes, i, _i, _i2;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.projectId = _this.$route.params.projectId;
              _this.reportId = _this.$route.params.reportId;

              if (!_this.$route.meta.pageKey) {
                _context.next = 23;
                break;
              }

              _this.pageKey = _this.$route.meta.pageKey;
              _context.next = 6;
              return (0, _report.informJSONInfo)({
                inform_id: _this.reportId,
                key: _this.pageKey
              });

            case 6:
              informRes = _context.sent;
              _context.next = 9;
              return (0, _common.getFile)(informRes.data.data);

            case 9:
              fileRes = _context.sent;
              _this.pageConfig = fileRes.data;
              console.log('pageConfig', _this.pageConfig);

              if (!(_this.pageConfig.score !== undefined)) {
                _context.next = 21;
                break;
              }

              i = 0;

            case 14:
              if (!(i < _report2.scoreLevel.length)) {
                _context.next = 21;
                break;
              }

              if (!(_this.pageConfig.score >= _report2.scoreLevel[i].score[0] && _this.pageConfig.score < _report2.scoreLevel[i].score[1])) {
                _context.next = 18;
                break;
              }

              _this.score = _report2.scoreLevel[i].name;
              return _context.abrupt("break", 21);

            case 18:
              i++;
              _context.next = 14;
              break;

            case 21:
              for (_i = 0; _i < _this.pageConfig.chartInfo.length; _i++) {
                _this.activeNames.push(_i + '');
              }

              for (_i2 = 0; _i2 < _this.pageConfig.optimize.length; _i2++) {
                _this.activeNamesDrawer.push(_this.pageConfig.optimize[_i2].help);
              }

            case 23:
              console.log('reportDevice', _this.reportDevice);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    parseTime: _utils.parseTime,
    drawerClose: function drawerClose() {
      this.drawer = false;
    },
    drawerShow: function drawerShow() {
      if (this.pageConfig.optimize.length) {
        this.drawer = true;
      }
    },
    gotoCompare: function gotoCompare() {
      // console.log('projectInfo',this.projectInfo.game_id, 'reportInfo', this.reportInfo.inform_id)
      this.$router.push({
        name: 'ReportCompare',
        params: {
          projectId: this.projectId,
          reportId: this.reportId
        }
      });
    },
    changeArrow: function changeArrow(index) {
      this.drawerList[index].arrow = !this.drawerList[index].arrow;
    }
  }
};
exports.default = _default;